export default __webpack_public_path__ + "static/media/insta.23945208.svg";